import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Settings, Save } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Parametres = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [config, setConfig] = useState({
    slack_webhook_url: ''
  });

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await axios.get(`${API}/config`, {
        withCredentials: true
      });
      setConfig({
        slack_webhook_url: response.data.slack_webhook_url || ''
      });
    } catch (error) {
      console.error('Error fetching config:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/config`, config, {
        withCredentials: true
      });
      toast.success('Configuration enregistrée avec succès');
    } catch (error) {
      console.error('Error saving config:', error);
      toast.error('Erreur lors de l\'enregistrement');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#002255]"></div>
      </div>
    );
  }

  return (
    <div data-testid="parametres-page">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#002255] mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Paramètres
        </h1>
        <p className="text-gray-600">Configurez votre CRM</p>
      </div>

      <form onSubmit={handleSave}>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200/40 p-6 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-[#002255]/10 rounded-lg flex items-center justify-center">
              <Settings className="w-5 h-5 text-[#002255]" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-[#002255]" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Intégrations
              </h2>
              <p className="text-sm text-gray-600">Connectez vos outils externes</p>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <Label htmlFor="slack_webhook">Slack Webhook URL</Label>
              <Input
                id="slack_webhook"
                type="url"
                value={config.slack_webhook_url}
                onChange={(e) => setConfig({ ...config, slack_webhook_url: e.target.value })}
                placeholder="https://hooks.slack.com/services/..."
                data-testid="input-slack-webhook"
              />
              <p className="text-sm text-gray-500 mt-1">
                Recevez des notifications Slack lorsqu'une offre est inscrite sur la plateforme
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200/40 p-6">
          <h2 className="text-lg font-semibold text-[#002255] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Configuration Email (Prochainement)
          </h2>
          <p className="text-gray-500">La configuration des emails sera disponible dans une prochaine version.</p>
        </div>

        <div className="mt-6">
          <Button
            type="submit"
            disabled={saving}
            className="bg-[#002255] hover:bg-[#002255]/90"
            data-testid="save-config-button"
          >
            {saving ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Enregistrement...
              </>
            ) : (
              <>
                <Save className="w-4 h-4 mr-2" />
                Enregistrer
              </>
            )}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Parametres;
